module.exports = __webpack_public_path__ + "aff3b04af4ebac602e243e79fe4333f7.svg";